
import {DialogEvents} from "@/constantes/events";
import { defineComponent } from "vue";

export default defineComponent({
    name: "TheDialog",
    props: {
        message: {
            type: String,
            required: true
        },
        textButtonValidation: {
            type: String,
            required: true
        },
        textButtonCancel: {
            type: String,
            required: false
        },
    },
    emits: [DialogEvents.DIALOG_CLOSE_CANCEL, DialogEvents.DIALOG_CLOSE_VALID],
    methods: {
        validation() {
            this.$emit(DialogEvents.DIALOG_CLOSE_VALID);
        },
        cancel() {
            this.$emit(DialogEvents.DIALOG_CLOSE_CANCEL);
        }
    }
})
